
export const relatorios = {
  servicoTecnicos: 'servico-tecnicos',
  atendimentoEmpresa: 'atendimento-empresa',
  resumoServicos: 'resumo-servicos',
  servicosProdutor: 'servico-produtor',
}

export const relatoriosString = Object.values(relatorios)

export const StatusLog = {
  EM_ANDAMENTO: 'EM ANDAMENTO',
  FINALIZADO: 'FINALIZADO',
  CANCELADO: 'CANCELADO',
  ERROR: 'ERROR',
}

export const TypeFile = {
  XLSX: 0,
  PDF: 1,

  values () {
    return [
      this.XLSX,
      this.PDF,
    ]
  },

  getDescription (status) {
    switch (status) {
      case this.XLSX:
        return 'xlsx'
      case this.PDF:
        return 'pdf'
      default:
        return ''
    }
  },

  getTypes (status) {
    switch (status) {
      case this.XLSX:
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      case this.PDF:
        return 'application/pdf'
      default:
        return ''
    }
  },
}

export const TipoSupervisor = {
  ADM: 0,
  CAMPO: 1,

  values () {
    return [
      this.ADM,
      this.CAMPO,

    ]
  },

  getDescription (status) {
    switch (status) {
      case this.ADM:
        return 'Administrativo'
      case this.CAMPO:
        return 'Campo'
      default:
        return ''
    }
  },
}

export const TypeProduto = {
  PRODUTO: 0,
  SERVICO: 1,

  values () {
    return [
      this.PRODUTO,
      this.SERVICO,
    ]
  },

  getDescription (status) {
    switch (status) {
      case this.PRODUTO:
        return 'Produto'
      case this.SERVICO:
        return 'Serviço'
      default:
        return ''
    }
  },
}
